import { DeviceSetup, Examination, TaskStep, TestData } from "graphql/types"
import { TaskAddDeviceCard } from "./TaskCards/TaskAddDeviceCard"
import { TaskFunctionCard } from "./TaskCards/TaskFunctionCard"
import { TaskHelperCard } from "./TaskCards/TaskHelperCard"
import { TaskNoteCard } from "./TaskCards/TaskNoteCard"
import { TaskTestConfigurationCard } from "./TaskCards/TaskTestConfigurationCard"
import { TaskTestFollowUpCard } from "./TaskCards/TaskTestFollowUpCard"
import { TaskWaitingCard } from "./TaskCards/TaskWaitingCard"

type TaskStepSwitchProps = {
  testData: TestData
  deviceSetup: DeviceSetup[]
  examination: Examination
}

export const TaskStepDataSwitch = (props: TaskStepSwitchProps) => {
  const { testData, deviceSetup, examination } = props

  switch (testData.type) {
    case TaskStep.NOTE:
    case TaskStep.ENGINEERING:
      return <TaskNoteCard testData={testData} />
    case TaskStep.ADD_DEVICE:
      return <TaskAddDeviceCard deviceSetup={deviceSetup} />
    case TaskStep.FUNCTION_TEST:
      return <TaskFunctionCard testData={testData} criteriaCatalog={examination.passFailCriteria} />
    case TaskStep.TEST_CONFIGURATION:
      return <TaskTestConfigurationCard testData={testData} examination={examination} />
    case TaskStep.TEST_FOLLOW_UP:
      return (
        <TaskTestFollowUpCard testData={testData} criteriaCatalog={examination.passFailCriteria} />
      )

    case TaskStep.WAITING_TIME:
      return <TaskWaitingCard testData={testData} />
    case TaskStep.HELPER:
      return <TaskHelperCard testData={testData} />
    default:
      return null
  }
}
